<template>
    <div :class="['page-wrap', {
        isIos: !isIos
    }]">
        <!-- <div class="page-loading" v-if="pageIn">
            <van-loading type="spinner" size="34px" vertical>正在加载…</van-loading>
        </div> -->
        <!-- banner样式 -->
        <div class="page-banner">
            <div class="page-banner-bg" v-if="!isShow"><img src="https://cdncos.aigupiao.com/assets/aiguquan/svg/stock_pool/icon_bg_s.png" alt=""></div>
            <div class="page-banner-bg" v-else><img src="https://cdncos.aigupiao.com/assets/aiguquan/svg/stock_pool/icon_bg_big_1_s.png" alt=""></div>
            <div class="page-banner-content">
                <button v-if="!isH5 && isShowShare" class="page-banner-content-share" @click.stop.prevent="shareOpen"></button>
                <h1 class="page-banner-title">趋势精选股票池</h1>
                <div class="page-banner-box">
                    <div class="page-banner-left">
                        <p class="page-banner-time" v-if="dateStr">{{dateStr}}更新</p>
                        <div @click.stop.prevent="isShow = !isShow" :class="{bindShow: isShow}">
                            <span></span><button></button><i></i>
                        </div>
                    </div>
                    <div :class="['page-banner-right', {isTop: !isShow}]">
                        <button class="page-banner-only">会员剩余日期:{{days}}天</button>
                        <span class="page-banner-line"></span>
                        <button class="page-banner-btn" @click.stop.prevent="renewFn">{{ not_vip ? '开通' : '续费'}}</button>
                    </div>
                </div>
                <div class="page-banner-text" v-if="isShow">
                    <p>根据大数据多维度选出正处于上升趋势，成交量和市场关注度较高，中线热门题材，主流机构和量化资金抱团的活跃股。每日收盘后一小时内更新。</p>
                    <p v-if="false">产品证书号：A0690621010001</p>
                </div>
            </div>
        </div>

        <!-- 轮播 战绩榜 swiper-no-swiping 禁止手动滑动 -->
        <div class="top-stock-list-wrap" v-if="top_list.length > 0">
            <div class="top-stock-list swiper2">
                <div class="swiper-container">
                    <div class="swiper-wrapper swiper-no-swiping">
                        <div
                            class="swiper-slide"
                            v-for="(item, i) in top_list"
                            :key="'ing_' + i"
                        >
                        <span class="top-stock-list-item"
                            :data-stock="item.code"
                            :data-name="item.name"
                        >{{ item.text }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="top-stock-list-under"></div>
        </div>


        <!-- 股票数 -->
        <div class="page-stock-num">
            <p v-if="currentTimeFn()">{{not_vip && !codeLen ? '--' : codeLen}}只股票入选</p>
            <p v-else>{{not_vip && !codeLen ? '--' : codeLen}}只股票入选</p>

            <div class="page-stock-picker" @click.stop.prevent="showTab" v-if="currentTime">
                <span class="page-stock-picker-icon"></span>
                <span class="page-stock-picker-time">{{currentDaFn()}}</span>
                <span class="page-stock-picker-day">{{currentDayFn}}</span>
                <span class="page-stock-picker-arrow"></span>
            </div>
        </div>
        <!-- 股票列表 -->
        <div class="page-stock-wrap">
            <!-- div class="page-stock-left">
                <dl v-for="(item, index) in tabs" :key="index">
                    <dt>{{item.name}}</dt>
                    <dd 
                        v-for="(lItem, lIndex) in sortableList" 
                        :key="lIndex"
                        @click.stop.prevent="goDetail(lItem)"
                    >{{ lItem[item.type] }}</dd>
                </dl>
            </div>
            <div class="page-stock-right" @scroll="scrollFn" ref="page-stock-right">
                <dl 
                    v-for="(item, index) in tabs_1" 
                    :key="index"
                >
                    <dt
                        :class="[{
                            isSortAble: item.sortable,
                            isDesc: item.sortable && item.sortType == 'desc',
                            isAsc: item.sortable && item.sortType == 'asc',
                            // isCenter: item.isCenter
                        }]"
                        @click.stop.prevent="sortFn(item, index)"
                    >
                        {{item.name}}
                        <span v-if="item.sortable">
                            <i></i>
                            <i></i>
                        </span>
                    </dt>
                    <dd 
                        v-for="(lItem, lIndex) in sortableList" 
                        :key="lIndex"
                        :class="[{
                            isRed: item.isColor && lItem['chg_pct'] > 0,
                            isGreen: item.isColor && lItem['chg_pct'] < 0,
                            isCenter: item.isCenter
                        }]"
                        @click.stop.prevent="goDetail(lItem, item.type)"
                    >{{ stampFn(lItem, item) }} </dd>
                </dl>
            </div -->

            <!-- 顶部样式 -->
            <div :class="['sticky_top', isSource]">
                <!-- 左侧固定列 -->
                <div class="sticky_top_left">
                    <div v-for="(item, index) in tabs" :key="index">{{item.name}}</div>
                </div>
                <!-- 右侧滚动区域 -->
                <div
                    class="sticky_top_right"
                    @scroll="divScroll"
                    @touchmove="IOSdivScroll"
                    @touchstart="divTouchStart"
                    ref="rightBoxHead"
                >
                    <div>
                        <div
                            v-for="(item, index) in tabs_1" 
                            :key="index"
                            :class="[{
                                isSortAble: item.sortable,
                                isDesc: item.sortable && defaultSortTable == item.type && defaultSortType == 'desc',
                                isAsc: item.sortable && defaultSortTable == item.type && defaultSortType == 'asc',
                                // isCenter: item.isCenter
                            }]"
                            @click.stop.prevent="sortFn(item, index)"
                        >
                            {{item.name}}
                            <span v-if="item.sortable">
                                <i></i>
                                <i></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 主体样式 -->
            <div class="sticky_bottom">
                <!-- 左侧固定列 -->
                <div class="sticky_bottom_left">
                    <div>
                        <div 
                            v-for="(lItem, lIndex) in sortableList" 
                            :key="lIndex"
                            @click.stop.prevent="goDetail(lItem)"
                        >
                            {{lItem['name']}}
                        </div>
                    </div>
                </div>
                <!-- 右侧滚动区域 -->
                <div
                    class="sticky_bottom_right"
                    @scroll="divScroll"
                    @touchmove="IOSdivScroll"
                    @touchstart="divTouchStart"
                    ref="rightBoxContent"
                >
                    <div 
                        v-for="(item, index) in sortableList"
                        :key="index"
                    >
                        <div
                            v-for="(lItem, lIndex) in tabs_1" 
                            :key="lIndex"
                            :class="[{
                                isRed: lItem.isColor && item['chg_pct'] > 0,
                                isGreen: lItem.isColor && item['chg_pct'] < 0,
                                isCenter: lItem.isCenter
                            }]"
                            @click.stop.prevent="goDetail(item, lItem.type)"
                        >
                            {{ stampFn(item, lItem) }} 
                        </div>
                    </div>
                </div>
            </div>

            <span class="page-stock-tip" v-if="isFix"></span>
        </div>
        <div class="default-wrapper" v-if="loaded && sortableList && sortableList.length > 0">
            <p class="tips">没有更多了</p>
          </div>
        
        <div v-else-if="loaded && sortableList && sortableList.length == 0 && not_vip" class="empty_st">
            <img src="https://cdncos.aigupiao.com/assets/pc/img/2023/Frame11.svg" alt="">
            <div @click.stop.prevent="renewFn" class="btn">立即开通 查看今日股票池</div>
        </div>

        <div v-else-if="loaded && sortableList && sortableList.length == 0 && !not_vip" class="empty_st">
            <img src="https://cdncos.aigupiao.com/assets/wap/img/stockPool/empty.png" alt="">
            <p>{{loading? "加载中……": "暂无符合条件的股票"}}</p>
        </div>

        <div class="page-stock-footer">上述股票池仅供参考，并不保证收益。据此操作，风险自担。</div>
        <van-calendar
            v-if="minDate"
            type="single"
            v-model="show" 
            :default-date="currentTime"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            :show-confirm="false"
            @confirm="checkDate"
        />

        <div class="tanc_w" v-show="show_tip">
            <div class="tanc">
                <svg @click="show_tip = false;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4.63402 4.3513L15.9314 15.6487M4.06833 15.6487L15.3657 4.3513" stroke="#888888" stroke-width="1.6" stroke-linecap="round"/>
                </svg>
                <p class="tanc_fb margin8">{{show_data.stock_name}}（{{show_data.symbol}}）</p>
                <p class="margin8">现价：<span class="tanc_red">{{show_data.last_price}}  +{{show_data.chg_pct}}%</span> </p>
                <p class="margin8">30天入选：<span class="tanc_red">{{show_data.select_number}}次</span> </p>
                <div class="ckhq tanc_red2" @click="goDetail({
                    code:show_data.code,
                    name:show_data.stock_name,
                })">
                    查看行情
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none">
                        <path d="M1.37971 9.82031L5.62028 5.37953L1.37971 1.17969" stroke="#FF443D" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="rxls">
                    <div class="r_l"></div>
                    <span  class="tanc_fb span">入选历史</span>
                    <div class="r_l"></div>
                </div>

                <div class="rxls_box">
                    <div class="rxls_item">
                        <span class="tanc_c63">入选时间</span>
                        <span class="tanc_c63">历史推荐</span>
                    </div>
                    <div class="rxls_item" v-for="(item, index) in show_data.list" :key="index">
                        <span>{{item.date_ymd}}</span>
                        <span class="tanc_b" @click="showHistory(item)">
                            {{ not_vip && dateStr.includes(item.date_ymd) ? '开通后查看' : '查看' }}
                        </span>
                    </div>
                </div>

                <div class="kt_btn" v-if="not_vip"  @click.stop.prevent="renewFn">
                    立即开通
                </div>
            </div>
        </div>
        <!-- // href="http://quote.aigupiao.com/stock_m.php#AiGuPiao_StockCode=sh600498&name=烽火通信" -->
    </div>
</template>
<script>
import { appversion } from "@/utils/urlQuery";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
    name: "stockPool",
    data() {
        return {
            Authorization:decodeURI(this.$route.query.Authorization) ,
            from: this.$route.query.from || '',
            tabs: [
                // {
                //     name: "代码",
                //     type: "code"
                // }, 
                {
                    name: "名称",
                    type: "name"
                }
            ],
            defaultSortTable: "chg_pct",
            defaultSortType: "desc",
            tabs_1: [
                {
                    name: "现价",
                    type: "last",
                    isColor: true,
                }, {
                    name: "涨跌幅",
                    type: "chg_pct",
                    isColor: true,
                    sortable: true,
                    sortType: "desc",
                    isPercentage: true,
                }, {
                    name: "30天入选",
                    type: "count_within_30",
                    isUnit: true,
                    sortable: true,
                    isCenter: true
                }, {
                    name: "所属板块",
                    type: "theme_name",
                    isText: true,
                }, {
                    name: "成交额",
                    type: "amount",
                    sortable: true,
                    sortType: "",
                    isConversion: true,
                }, {
                    name: "换手率",
                    type: "turnover_rate",
                    sortable: true,
                    sortType: "",
                    isPercentage: true,
                }, {
                    name: "总市值",
                    type: "whole",
                    sortable: true,
                    sortType: "",
                    isConversion: true,
                }
            ],
            list: [],
            isFix: true,
            circleId: null, // 圈子ID
            dateStr: "",
            codeLen: 0,
            isShow: false,
            loaded: false,
            cureentDefault: "", // 环境
            days: 0, // 
            show: false,
            minDate: "",
            maxDate: "",
            currentTime: "", // 当前事件
            today: "",


            date:this.$route.query.date,//传参
            not_vip:false,//非会员
            show_tip:false,//弹窗
            show_data:{},//弹窗数据

            //战绩榜数据
            top_list:[],
            swiper2:null,
            disTimeArr: [],
            pageIn: true, // 页面进入后
            loading: false,
            isSource: "", // 版本
            startX: '',
            startY: "",
            isIos: false,
            userInfo: null,
            isH5: false,
            isShowShare: false,
        }
    },
    mounted() {
        let _this = this;
        $('body').on('click','.top-stock-list-item',function(){
            let code = $(this).attr('data-stock');
            _this.openDetail(code)
        })
    },
    created() {
        if(location.pathname == '/up/h5/stockPool') {
            this.isH5 = true;
        } else {
            this.isH5 = false;
            this.initApi();
            let APVERSION = appversion || "1000";
            if(APVERSION) {
                if(APVERSION.indexOf(".")>-1) {
                    APVERSION = APVERSION.split(".").join('')
                }
            }

            if(APVERSION >= 1271) {
                this.isShowShare = true;
            }
        }

        
    },
    
    watch: {
      '$store.state.user': {
        immediate: true,
        deep: true,
        handler(val, oldVal) {
          if(val.userId && val.user_app_token && !this.user_id && !this.userInfo) {
            this.userInfo = val;
          }

          
          if(location.pathname == '/up/h5/stockPool') {
            this.Authorization = "Bearer " + val.user_app_token
            this.initApi();
          }
        }
      }
    },
    methods: {
        shareOpen() {
            // followup_url
            this.$srH5CallNativeMethodApp('share_wx_link', {
                url: location.origin + "/StockPool/index", // /up/h5/stockPool
                title: "趋势精选-热点优选股票池",
                content: "根据大数据多维度选出正处于上升趋势，成交量和市场关注度较高，中线热题材，主流机构和量化资金抱团的活跃股。"
            })
        },
        initApi() {
            var u = navigator.userAgent,
                app = navigator.appVersion;
            var data = null;
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            let isSource = ""
            if (isAndroid) {
                isSource = 'app_versions_android'
            } else if (isiOS) {
                this.isIos = true;
                isSource = 'app_versions_ios'
            }
            console.info(this.isIos,'isIos')
            this.isSource = isSource;
            let today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            today.setMilliseconds(0);

            this.today = today;
            console.log('today',today)

            if(this.date){
                this.currentTime = new Date(this.date);
            }
            else{
                this.currentTime = today;
            }

            
            this.maxDate = today;

            this.minDate = new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)

            let _host = location.host, _currentDefault;
            if(_host.indexOf("dev") > -1 || _host.indexOf("8080") > -1) {
                _currentDefault = "dev"
            } else if(_host.indexOf("beta") > -1 ) {
                _currentDefault = "beta"
            } else {
                _currentDefault = ""
            }

            this.cureentDefault = _currentDefault;
            // 获取列表
            this.getStockPoolFn('save');

            this.getTopData();
        },
        showHistory(item){
            //判断日期是否是最新时间
            if(this.not_vip && this.dateStr.includes(item.date_ymd)){
                this.renewFn();
            }
            else{
                this.show_tip = false;
                this.checkDate(new Date(item.date_ymd));
            }
            
        },
        openDetail(code){
            let _this = this;
            //股票池战绩榜轮播信息
            //appbeta.aigupiao.com/goapi/stock/get_stock_pool_detail 
            $.ajax({ xhrFields: {withCredentials: true},
                type: 'get',
                dataType: 'json',
                url: `https://app${_this.cureentDefault}.aigupiao.com/goapi/stock/get_stock_pool_detail`,
                cache: false,
                async: true,
                beforeSend:function (request){
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                data:{stock:code},
                error: function(){return false;},
                success:function(res){
                    console.info(res,'__rse3')
                    if(res.code == 1){
                        _this.show_tip = true;
                        _this.show_data = res.data;
                        _this.show_data.code = code;
                    }
                    
                    
                }
            })
        },
        divTouchStart(event) {
            if(this.isIos) {
                this.startX = event.touches[0].clientX;
                this.startY = event.touches[0].clientY;
            }
        },
        //滚动条
        divScroll(event) {
            if(this.isIos) {
                
            } else {
                this.$refs.rightBoxContent.scrollLeft = event.target.scrollLeft
                this.$refs.rightBoxHead.scrollLeft = event.target.scrollLeft
            }
        },
        IOSdivScroll(event) {
            if(this.isIos) {
                // 计算移动的距离
                var currentX = event.touches[0].clientX;
                var currentY = event.touches[0].clientY;
                var distanceX = currentX - this.startX;
                var distanceY = currentY - this.startY;
                // 如果水平方向移动大于垂直方向，则进行横向滚动
                if (Math.abs(distanceX) > Math.abs(distanceY)) {
                    event.preventDefault(); // 阻止默认的垂直滚动
                    this.$refs.rightBoxContent.scrollLeft -= (distanceX/10)
                    this.$refs.rightBoxHead.scrollLeft -= (distanceX/10)
                }
            } else {
                
            }
        },
        getTopData(){
            let _this = this;
            //股票池战绩榜轮播信息
            //https://apidev.stock-ring.com/goapi/stock/stock_pool_rank
            $.ajax({ xhrFields: {withCredentials: true},
                type: 'get',
                dataType: 'json',
                url: `https://api${_this.cureentDefault}.stock-ring.com/goapi/stock/stock_pool_rank`,
                cache: false,
                async: true,
                error: function(){return false;},
                success:function(res){
                    console.info(res,'__-rse2')
                    _this.top_list = res.data;
                    _this.swiper();
                }
            })
        },
        swiper(){
            //战绩榜 滚动事件
            if(this.swiper2){
                //清楚 已有滚动
                this.swiper2.destroy(true);
            }
            if(this.top_list.length > 1){
                this.$nextTick(() => {
                    this.swiper2 = new Swiper(".swiper-container", {
                        autoplay: {
                                delay: 5000,
                                disableOnInteraction: false,
                            },
                            loop: true,
                            direction: 'vertical',
                    });
                });
            }
        },
        formatter(day) {
            let _date = new Date(day.date);
            let disTimeArr = this.disTimeArr, _m = _date.getMonth() + 1, _y = _date.getFullYear(), _d = _date.getDate();
            _m = _m < 10? '0' + _m: _m;
            _d = _d < 10? '0' + _d: _d;
            if(disTimeArr.indexOf(_y + '-' + _m + '-' + _d) > -1) {
                // console.info('rua')
            } else {
                day.type = 'disabled'
            }
            return day
        },
        showTab() {
            this.show = true;
        },
        checkDate(day) {
            console.log('day',day);
            this.show = false;
            this.currentTime = day;
            this.list = [];
            this.loading = true;
            
            setTimeout(()=>{
                this.getStockPoolFn('load')
            }, 250)
        },
        stampFn(lItem, item) {
            let _str = ""
            // 单位转换 - 亿 万
            if(item.isConversion) {
                let _val = lItem[item.type];
                let lItemVal = Math.abs(_val)
                if (lItemVal > 99999999) {
                    _str = (_val / 100000000).toFixed(2) + "亿";
                } else if (lItemVal > 9999) {
                    _str = (_val / 10000).toFixed(2) + "万";
                } else if (lItemVal == "--") {
                    _str = "0";
                } else {
                    _str = _val + "";
                }
            }
            // 是否开启了 百分比转换
            else if(item.isPercentage) {
                _str = (lItem[item.type] * 1).toFixed(2) + "%"
            }
            // 是否有单位次数
            else if(item.isUnit) {
                _str = (lItem[item.type] * 1) + '次'
            }
            // 是否要纯文字展示
            else if(item.isText) {
                _str = lItem[item.type];
            }
            else {
                _str = (lItem[item.type] * 1).toFixed(2);
            }
            return _str;
        },
        // 滚动方法
        scrollFn() {
            if($(this.$refs['page-stock-right']).scrollLeft() > 0) {
                this.isFix = false;
            }
            else {
                this.isFix = true;
            }
        },
        // 排序
        sortFn(item, index) {
            if(item.sortable) {
                if(item.type == this.defaultSortTable) {
                    if(this.defaultSortType == "desc") {
                        this.defaultSortType = "asc";
                    } else if(this.defaultSortType == "asc"){
                        this.defaultSortType = "desc"; 
                    }
                } else {
                    this.defaultSortType = "desc";
                    this.defaultSortTable = item.type;
                }
            }
        },
        // 跳转详情页
        goDetail(item, type) {
            if(type == "count_within_30") {
                this.openDetail(item.code)
                return
            }
            if(type == 'theme_name') {
                var u = navigator.userAgent;
                var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid) {
                    location.href = `http://quote.aigupiao.com/stock_m.php#AiGuPiao_jump_kind=theme&jump_id=${item.theme_id}`;    
                } else if (isiOS) {
                    location.href = `http://quote.aigupiao.com/stock_m.php#igpFunToAppJump_kind=theme&jump_id=${item.theme_id}`; 
                }
            } else {
                location.href = `http://quote.aigupiao.com/stock_m.php#AiGuPiao_StockCode=${item.code}&name=${item.name}`;
            }
            
        },
        // 获取股票池列表
        async getStockPoolFn(type) {
            let _this = this;
            let data = {};
            if(!this.currentTimeFn()) {
                data.date_ymd = this.currentDaFn()
            }
            console.info(this.$store.state.user.user_app_token, '$store')
            $.ajax({ xhrFields: {withCredentials: true},
                type: 'post',
                dataType: 'json',
                url: `https://app${_this.cureentDefault}.aigupiao.com/goapi/stock/get_stock_pool`,
                data,
                cache: false,
                async: true,
                beforeSend:function (request){
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                error: function(){return false;},
                success:function(res){
                    if(!data.date_ymd && _this.from == 'applink' && (res.data.is_vip == 'no' || (res.code != 1 && res.message!="仅会员支持查看趋势精选")) && res.data.stock_pool_list.length == 0) {
                        location.href = `${location.origin}/StockPool/index?u_id=${_this.$route.query.agp_u_id || _this.$route.query.u_id || _this.$route.query.user_id || ''}&kind=QSJX&Authorization=${_this.Authorization}`
                        return
                    }
                    // 请求成功
                    if(res.code == 1 || res.message=="仅会员支持查看趋势精选") {
                        _this.not_vip = res.data.is_vip == 'no' ? true : false;

                        _this.list = res.data.stock_pool_list;
                        let _empty = [];
                        for(let i=0,ilen=res.data.stock_pool_date_list.length;i<ilen;i++) {
                            _empty.push(res.data.stock_pool_date_list[i]['day'])
                        }

                        if(_this.list.length == 0 && !data.date_ymd) {
                            // _this.checkDate();
                        }
                        //更新 时间显示可能有问题
                        _this.dateStr = res.data.update_time;
                        if(type == 'save') {
                            _this.dateStr = res.data.update_time;
                            if(!data.date_ymd && _empty.indexOf(_this.dateStr) == -1 && res.data.stock_pool_length > 0) {
                                _empty.unshift(_this.dateStr)
                            }
                            _this.disTimeArr = _empty;
                            _this.maxDate = new Date(_empty[0].replace(/-/g,'/'));
                            _this.minDate = new Date(_empty[_empty.length-1].replace(/-/g,'/'));
                            
                            if(_this.date){
                                
                            }
                            else{
                                _this.currentTime = _this.maxDate;
                            }
                            

                            // _this.pageIn = false;
                            _this.$nextTick(()=>{
                                let _loading = document.getElementsByClassName("w_page-loading")[0]
                                _loading.style.display = "none"
                            })
                        }
                        _this.codeLen = res.data.stock_pool_length
                        _this.days = res.data.vip_day_num;
                    } else {
                        if(type == 'save') {
                            _this.$nextTick(()=>{
                                let _loading = document.getElementsByClassName("w_page-loading")[0]
                                _loading.style.display = "none"
                            })
                        }
                        _this.not_vip = true;
                    }
                    _this.loaded = true;
                    _this.loading = false;
                }
            })
        },
        // 点击续费按钮
        renewFn() {
            if(this.isH5) {
                if(this.Authorization && this.userInfo) {
                    this.$downapppop.open('查看');
                    return
                } else {
                    let current = "";
                    if(location.origin.indexOf("dev") > -1) {
                        current = "dev"
                    }
                    this.origin = "https://mobile" + current + ".aigupiao.com"
                    location.href = origin + "/login/index/rd/980880418.html?redirect=" + encodeURIComponent(location.href)
                    return
                }
            }
            let _str = "_str=stockPool#AiGuPiao_ThirdPay";
            if(location.href.indexOf('?') > -1) {
                location.href += ('&'+_str)
            } else {
                location.href += ('?'+_str)
            }
            window.open(_url)
        },
        currentTimeFn() {
            return new Date(this.currentTime).getTime() == new Date(this.maxDate).getTime()
        },
        currentDaFn() {
            let nowDa = new Date(this.currentTime);
            let _y = nowDa.getFullYear();
            let _m = nowDa.getMonth() + 1;;
            let _d = nowDa.getDate();

            _m = _m<10? '0' + _m: _m;
            _d = _d<10? '0' + _d: _d;

            return `${_y}-${_m}-${_d}`
        },
    },
    computed: {
        sortableList() {
            let list = this.list || [];
            let sort_type = this.defaultSortTable;
            list.sort((a,b)=>{
                if(this.defaultSortType == 'asc') {
                    return a[sort_type] - b[sort_type]
                } else {
                    return b[sort_type] - a[sort_type]
                }
            })
            return list
        },
        currentDayFn() {
            let nowDa = new Date(this.currentTime)
            return '周' + '日一二三四五六'.charAt(nowDa.getDay())
        }
    }
}
</script>
<style scoped lang="scss">
* {
    touch-action: unset;
}
.page-wrap {
    width: 100%;
    height: auto;
    position: relative;
    min-height: 100vh;
    background-color: #fff;

    &.isIos {
        .sticky_top_right, .sticky_bottom_right {
            overflow-x: auto !important;
        }
    }

    // 加载中样式
    .page-loading {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        z-index: 999;
        background-color: rgba(256, 256, 256,  1);
        display: flex;
        align-items: center;
        justify-content: center;

        .van-loading__text {
            margin-top: 14px;
        }
    }

    .page-banner {
        width: 100%;
        height: auto;
        position: relative;
        overflow: hidden;

        .page-banner-bg {
            width: 100%;
            height: auto;

            img {
                width: 100%;
                height: auto;
                display: block;
            }
        }

        .page-banner-content {
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            height: auto;
            top: 40px;

            .page-banner-content-share {
                position: absolute;
                right: 12px;
                top: -24px;
                width: 63px;
                height: 22px;
                background-color: transparent;
                background-image: url("https://cdncos.aigupiao.com/assets/app/svg/shareIcon.svg");
                background-repeat: no-repeat;
                background-size: 100%;
                border: none;
                outline: none;
            }

            .page-banner-title {
                color: #FFFFFF;
                font-size: 22px;
                line-height: 31px;
                padding-left: 12px;
                box-sizing: border-box;
                font-weight: bold;
            }

            .page-banner-box {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                margin-top: 20.5px;
                height: 27px;
                padding-right: 12.5px;
                box-sizing: border-box;

                .page-banner-left {
                    display: flex;
                    flex-direction: row;
                    .page-banner-time {
                        font-size: 13px;
                        line-height: 18.5px;
                        color: #FFFFFF;
                        margin-left: 15px;
                    }

                    div {
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        &.bindShow {
                            i {
                                transform: rotate(-180deg);
                            }
                        }
                        
                        span {
                            width: 1px;
                            height: 14px;
                            display: inline-block;
                            background-color: transparent;
                            background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/stock_pool/icon_line.svg");
                            background-size: 1px 14px;
                            background-repeat: no-repeat;
                            margin-left: 8px;
                        }

                        button {
                            width: 21px;
                            height: 13px;
                            box-sizing: border-box;
                            padding-left: 8.5px;
                            background-color: transparent;
                            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/msg.png");
                            background-size: 12.5px 13px;
                            background-repeat: no-repeat;
                            background-position: 8.5px center;
                            border: none;
                            outline: none;
                        }

                        i {
                            width: 5.5px;
                            height: 4px;
                            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/arrow.png");
                            background-size: 100% 100%;
                            background-repeat: no-repeat;
                            background-position: center center;
                            margin-left: 5px;
                        }
                    }
                }
                .page-banner-right {
                    width: auto;
                    height: auto;
                    background-color: rgba(255, 154, 114, 0.79);
                    border-radius: 5.5px;
                    display: inline-flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 4px 7px 4.5px 8.5px;

                    &.isTop {
                        .page-banner-arrow {
                            background-image: url("https://cdncos.aigupiao.com/assets/wap/img/stockPool/icon_top.svg");
                        }
                    }

                    .page-banner-only {
                        padding-left: 3.5px;
                        font-size: 13px;
                        line-height: 18.5px;
                        color: #F5FFCC;
                        border: none;
                        outline: none;
                        background-color: transparent;
                        padding-right: 6px;
                    }

                    .page-banner-line {
                        width: 1px;
                        height: 15.5px;
                        display: inline-block;
                        background-color: transparent;
                        background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/stock_pool/icon_line.svg");
                        background-size: 1px 15.5px;
                        background-repeat: no-repeat;
                    }

                    .page-banner-btn {
                        background-color: transparent;
                        border: none;
                        font-size: 12px;
                        line-height: 16.5px;
                        color: #F5FFCA;
                        background-image: url("https://cdncos.aigupiao.com/assets/wap/img/stockPool/arrow_1.svg");
                        background-size: 5px 9px;
                        background-repeat: no-repeat;
                        background-position: right;
                        padding-right: 8px;
                        padding-left: 6px;
                    }
                }
            }

            .page-banner-text {
                font-size: 12px;
                line-height: 19px;
                color: #F5FFCA;
                padding: 0 15px;
                margin-top: 16px;
            }
        }
    }

    .page-stock-num {
        height: 41px;
        line-height: 41px;
        width: 100%;
        border-bottom: 0.5px solid #EBEBEB;
        padding-left: 12px;
        padding-right: 10.5px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        p {
            font-size: 14px;
            color: #636363;
        }

        .page-stock-picker {
            width: auto;
            height: 27px;
            display: flex;
            flex-direction: row;
            align-items: center;
            border-radius: 5px;
            border: 0.5px solid #DBDBDB;
            padding: 0 8px 0 9.5px;

            .page-stock-picker-icon {
                width: 12.5px;
                height: 12.5px;
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/date.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: center center;
                margin-right: 4.5px;
            }

            .page-stock-picker-time {
                font-size: 12px;
                height: 27px;
                line-height: 27px;
                color: #939393;
                margin-right: 8px;
            }

            .page-stock-picker-day {
                font-size: 12px;
                height: 27px;
                line-height: 27px;
                color: #939393;
                margin-right: 6px;
            }

            .page-stock-picker-arrow {
                width: 9px;
                height: 5px;
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/bottom_arrow.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: center center;
            }
        }
    }

    .page-stock-wrap {
        width: 100%;
        height: auto;
        padding-bottom: 20px;
        /* display: flex;
        flex-direction: row; */

        .page-stock-left {
            display: flex;
            flex-direction: row;
            width: 25%;

            dl {
                overflow: hidden;

                &:first-of-type{
                    flex: 1.4;
                }
                &:last-of-type{
                    flex: 1;
                }
            }
        }

        .page-stock-right {
            display: flex;
            flex-direction: row;
            width: 60%;
            flex: 1;
            overflow: hidden;
            overflow-x: auto;
            position: relative;

            dl {
                min-width: 85px;
                width: 25%;
            }
            
            span {
                &.page-stock-tip {
                    width: 5.5px;
                    height: 9px;
                    position: absolute;
                    right: 10px;
                    top: 16.5px;
                    background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/arrow.svg");
                    background-repeat: no-repeat;
                    background-size: 100%;
                }
            }
        }

        dl {

            &:first-of-type {
                dt,dd {
                    padding-left: 12.5px;
                }
            }

            dt {
                height: 41px;
                line-height: 41px;
                font-size: 13px;
                color: #636363;
                border-bottom: 0.5px solid #EBEBEB;
                position: relative;

                &.isSortAble {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    &.isDesc {
                        span {
                            i {
                                background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle.svg");
                                transform: rotate(180deg);

                                &:last-of-type {
                                    background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle_check.svg");
                                    transform: rotate(180deg);
                                    margin-top: 3px;
                                }
                            }
                        }
                    }

                    &.isAsc {
                        span {
                            i {
                                background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle_check.svg");
                                transform: rotate(0deg);

                                &:last-of-type {
                                    background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle.svg");
                                    transform: rotate(0deg);
                                    margin-top: 3px;
                                }
                            }
                        }
                    }

                    span {
                        display: inline-flex;
                        flex-direction: column;
                        margin-left: 3.5px;

                        i {
                            display: inline-block;
                            width: 6.5px;
                            height: 4.5px;
                            background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle.svg");
                            background-size: 100%;
                            background-repeat: no-repeat;
                            transform: rotate(-180deg);

                            &:last-of-type {
                                transform: rotate(0deg);
                                margin-top: 3px;
                            }
                        }
                    }
                }

                &.isCenter {
                    text-align: center
                }
            }

            dd {
                height: 42px;
                line-height: 42px;
                font-size: 14px;
                color: #333333;
                border-bottom: 0.5px solid #EBEBEB;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;

                &.isGreen {
                    color: #0AC890;
                    font-weight: bold;
                }

                &.isRed {
                    color: #FE484A;
                    font-weight: bold;
                }

                &.isCenter {
                    // text-align: center;
                    padding-left: 15px;
                    // box-sizing: border-box;
                }
            }
        }

        .sticky_top {
            width: 100%;
            display: flex;
            background-color: #fff;
            border-bottom: .5px solid #ebebeb;

            &.app_versions_android {
                position: sticky;
                top: 0;
                z-index: 10;
            }

            &.app_versions_ios {
                
            }

            .sticky_top_left {
                display: flex;
                height: 40px;
                line-height: 40px;
                width: 90px;
                font-size: 13px;
                color: #636363;
                padding-left: 12.5px;
                box-sizing: border-box;
            }

            .sticky_top_right {
                flex: 1;
                white-space: nowrap;
                overflow-x: hidden;

                > div {
                    display: flex;
                    
                    > div {
                        height: 40px;
                        line-height: 40px;
                        min-width: 85px;
                        width: 25%;
                        font-size: 13px;
                        color: #636363;
                        box-sizing: border-box;

                        &:first-of-type {
                            padding-left: 12.5px;
                        }

                        &.isSortAble {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
        
                            &.isDesc {
                                span {
                                    i {
                                        background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle.svg");
                                        transform: rotate(180deg);
        
                                        &:last-of-type {
                                            background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle_check.svg");
                                            transform: rotate(180deg);
                                            margin-top: 3px;
                                        }
                                    }
                                }
                            }
        
                            &.isAsc {
                                span {
                                    i {
                                        background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle_check.svg");
                                        transform: rotate(0deg);
        
                                        &:last-of-type {
                                            background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle.svg");
                                            transform: rotate(0deg);
                                            margin-top: 3px;
                                        }
                                    }
                                }
                            }
        
                            span {
                                display: inline-flex;
                                flex-direction: column;
                                margin-left: 3.5px;
        
                                i {
                                    display: inline-block;
                                    width: 6.5px;
                                    height: 4.5px;
                                    background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle.svg");
                                    background-size: 100%;
                                    background-repeat: no-repeat;
                                    transform: rotate(-180deg);
        
                                    &:last-of-type {
                                        transform: rotate(0deg);
                                        margin-top: 3px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .sticky_bottom {
            width: 100%;
            display: flex;

            .sticky_bottom_left {
                display: flex;
                
                >div {

                    >div {
                        height: 40px;
                        line-height: 40px;
                        width: 90px;
                        font-size: 14px;
                        color: #333;
                        padding-left: 12.5px;
                        box-sizing: border-box;
                        border-bottom: 0.5px solid #EBEBEB;
                    }
                }
            }

            .sticky_bottom_right {
                flex: 1;
                white-space: nowrap;
                overflow-x: hidden;

                > div {
                    display: flex;

                    > div {
                        height: 40px;
                        line-height: 40px;
                        min-width: 85px;
                        width: 25%;
                        font-size: 14px;
                        color: #333;
                        border-bottom: 0.5px solid #EBEBEB;
                        position: relative;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        box-sizing: border-box;

                        &:first-of-type {
                            padding-left: 12.5px;
                        }

                        &.isGreen {
                            color: #0AC890;
                            font-weight: bold;
                        }
        
                        &.isRed {
                            color: #FE484A;
                            font-weight: bold;
                        }
        
                        &.isCenter {
                            // text-align: center;
                            padding-left: 15px;
                            // box-sizing: border-box;
                        }
                    }
                }
            }
        }
    }

    .page-stock-footer {
        background-color: #F5F6F7;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 33px;
        line-height: 33px;
        text-align: center;
        font-size: 12px;
        color: #939393;
    }
}
.empty_st {
    padding: 0 60px;

    img {
        width: 100%;
        height: auto;
        display: block;
        margin-top: 25px;
        margin-bottom: 26.5px;
    }

    p {
        font-size: 15px;
        line-height: 21px;
        color: #636363;
        text-align: center;
        user-select: none;
    }

    .btn{
        display: flex;
        height: 40px;
        padding: 0px 18px;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        background: linear-gradient(180deg, #EB8057 0%, #EC5E3A 100%);
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 20px auto;
        box-sizing: border-box;
        width: max-content;
}
}
.default-wrapper {
    text-align: center;
    height: 35px;
  }
  .tips {
    font-size: 12px;
    line-height: 35px;
    color: #999;
  }

  .wrapper {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  



  .swiper2{
        width: 100%;
        height: 37px;
        line-height: 37px;
    }
    .swiper2 .swiper-container{
        height: 100%;
    }
    .swiper2 .swiper-slide div{
        box-sizing: border-box;
        height: 100%;
        line-height: 200px;
        background-color: lightblue;
        text-align: center;
        border-bottom: 1px solid #e5e5e5;
    }
    .top-stock-list-item{
        padding-left: 44px;
        font-size: 14px;
        font-weight: 400;
        color: #FF5117;
        background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/top-stock-list-item.png) no-repeat;
        background-size: 15px 11px;
        background-position: 10px center;
        position: relative;
        height: 37px;
        line-height: 37px;
        display: inline-block;

        &::before{
            content: "";
            display: block;
            position: absolute;
            width: 1px;
            height: 19px;
            background: #E8E8E8;
            top: 10px;
            left: 33px;
        }
    }
    .top-stock-list-under{
        width: 100%;
        height: 6px;
        background: #F8F8F8;
    }


.tanc_w{
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    background: rgba($color: #000000, $alpha: .4);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 20px;
    color: #333;
}
.tanc{
    width: 265px;
    //height: 379px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 3px solid #EDD8A9;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.00) 100%), linear-gradient(180deg, #F7E4C8 0%, #FFF 44.33%);
    padding: 24px;
    box-sizing: border-box;
    position: relative;
}
.tanc >svg{
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    position: absolute;
    top: 16px;
    right: 16px;
}
.tanc_red{
    color: #CB382D;
}
.tanc_red2{
    color: #FF443D;
}
.tanc_c63{
    color: #636363;
}
.tanc_b{
    color: #1D88D0;
}
.tanc_f13{
    font-size: 13px;
}
.tanc_fb{
    font-weight: bold;
}
.ckhq{
    display: flex;
    width: 220px;
    height: 31px;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
    flex-shrink: 0;
    border-radius: 21px;
    border: 1px solid #FF443D;
}
.ckhq >svg{
    width: 6px;
    height: 12px;
    flex-shrink: 0;
    margin-left: 6px;
}
.margin8{
    margin-bottom: 8px;
}
.rxls{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 17px 0;
}
.tanc_fb.span{
    margin: 0 10px;
}
.r_l{
    width: 50px;
    height: 1px;
    background: #EBEBEB;
    background-blend-mode: plus-darker;
}
.rxls_item{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.kt_btn{
    display: flex;
    width: 100%;
    box-sizing: border-box;
    height: 36px;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
    flex-shrink: 0;
    border-radius: 21px;
    background: linear-gradient(180deg, #EB8057 0%, #EC5E3A 100%);
    color: #FFF;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
</style>
